var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrandLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 523.4 225.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "brand-logo_svg__st0",
    d: "M63.1 162.2V89.9h33c15 0 25.8 13.7 25.8 27 0 13.8-10.1 27-25.3 26.6H84.2v18.7H63.1zM84.2 125h11.1c2.6 0 5.3-2.1 5.3-8.3 0-6.5-3.2-8.3-5.8-8.3H84.2V125zM136.5 162.2V89.9h21v72.3h-21zM393.9 108.5h-22v53.7h-21v-53.7h-22.1V89.9H394v18.6h-.1zM196.9 126.6v35.6h-21V89.9h16.4l30.8 36.8V89.9h21v72.3h-16.7l-30.5-35.6zM175.9 63.1h68.2v16h-68.2zM312.9 162.2h22.3l-28.6-72.3H285.4l-28.6 72.3h22.3l3.9-10.7h26l3.9 10.7zm-24.1-26.7l7.2-20.1 7.2 20.1h-14.4zM443.6 162.2h22.3l-28.6-72.3H416.1l-28.6 72.3h22.3l3.9-10.7h26l3.9 10.7zm-24.1-26.7l7.2-20.1 7.2 20.1h-14.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "brand-logo_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "brand-logo_svg__st0",
    d: "M463 102.7c-4.4 0-8.1-3.5-8.1-8.4s3.7-8.4 8.1-8.4 8.1 3.5 8.1 8.4-3.7 8.4-8.1 8.4zm0-15.4c-3.7 0-6.8 3-6.8 7.1 0 4.2 3.1 7.1 6.8 7.1 3.7 0 6.8-3 6.8-7.1 0-4.2-3-7.1-6.8-7.1zm-1.5 8v3.4H460v-8.8h3.5c1.8 0 3 1 3 2.7 0 1.4-.8 2.3-2.1 2.6l2.4 3.5h-1.7l-2.2-3.4h-1.4zm2-4.1h-2.1v2.7h2.1c.9 0 1.5-.6 1.5-1.3s-.5-1.4-1.5-1.4z"
  }))));
}

export default SvgBrandLogo;